exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create[data-v-71ef7437] {\n  margin-top: 3rem;\n  margin-bottom: 1.5rem;\n}\n#content__header[data-v-71ef7437] {\n  margin-bottom: 0;\n}\n.activity-date[data-v-71ef7437], .other-activities[data-v-71ef7437] {\n  margin-top: 3rem;\n}", ""]);

// exports
